const styles = (theme) => ({
  root: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing.unit * 2,
    },

    '& .CardIcon': {
      marginTop: '0px',
      [theme.breakpoints.up('md')]: {
        marginBottom: '40px',
      },
    },
  },
  rootNoRequests: {
    marginBottom: theme.spacing.unit / 2,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing.unit,
    },
  },
  jobSummaryContainer: {
    margin: `0 ${theme.spacing.unit * 2}px`,
    boxShadow: 'none',
    paddingBottom: theme.spacing.unit,
    borderBottom: `1px solid ${theme.palette.border.light}`,
    '&:last-child': { borderBottom: 'none' },
  },
  expandContainer: {
    flexWrap: 'wrap',
  },
  headingContainer: {
    width: '100%',
  },
  jobSummaryIcon: {
    marginLeft: 0,
    marginRight: theme.spacing.unit * 2,
    height: 40,
    width: 40,
    padding: theme.spacing.unit,
    backgroundColor: theme.palette.background.lighter,
    color: theme.palette.custom.maintenance,
  },
  jobSummaryTitle: {
    display: 'inline-block',
  },
  detailsContainer: {
    width: '100%',
    paddingTop: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing.unit * 7,
    },
  },
  jobSummaryLocation: {
    fontWeight: 500,
  },
  jobSummaryDetails: {
    display: 'inline-block',
  },
  expandIcon: {
    '& svg': {
      fontSize: '2rem',
      width: '2rem',
      height: '2rem',
    },
  },
  removeButtonContainer: {
    position: 'absolute',
    right: 0,
    top: theme.spacing.unit,
  },
  removeIcon: {
    padding: 2,
  },
  expansionPanelDivider: {
    marginBottom: theme.spacing.unit,
  },
  expansionPanelDetails: {
    paddingLeft: 0,
    paddingRight: 0,
    '& div': {
      width: '100%',
    },
  },
  jobSummaryComments: {
    whiteSpace: `pre-wrap`,
    '& .ItemIcon': {
      backgroundColor: theme.palette.background.lighter,
      color: theme.palette.custom.maintenance,
    },
    '& div': {
      marginLeft: -4,
    },
  },
});

export default styles;
